export default {
  programsList: [],
  manageProgram: null
}
